import React, { useState, useEffect } from "react";
import {
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TablePagination,
  Button,
  Typography,
  Modal,
  Box,
  Paper,
} from "@mui/material";
import { collection, getDocs, deleteDoc, doc } from "firebase/firestore";
import { db } from "../../firebaseConfig.js";

const Companies = () => {
  const [companies, setCompanies] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const companiesPerPage = 10;
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Obtener todos los datos de empresas desde Firestore
  useEffect(() => {
    const fetchCompanies = async () => {
      const querySnapshot = await getDocs(collection(db, "empresas"));
      const fetchedCompanies = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setCompanies(fetchedCompanies);
    };
    fetchCompanies();
  }, []);

  // Eliminar una empresa
  const handleDeleteCompany = async (id) => {
    try {
      await deleteDoc(doc(db, "empresas", id));
      setCompanies(companies.filter((company) => company.id !== id));
    } catch (error) {
      console.error("Error al eliminar la empresa:", error);
    }
  };

  // Modal para ver detalles de la empresa
  const handleOpenModal = (company) => {
    setSelectedCompany(company);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setSelectedCompany(null);
    setIsModalOpen(false);
  };

  // Paginación
  const handleChangePage = (event, newPage) => {
    setCurrentPage(newPage);
  };

  const currentCompanies = companies.slice(
    currentPage * companiesPerPage,
    currentPage * companiesPerPage + companiesPerPage
  );

  return (
    <Box sx={{ p: 3 }}>
      {/* Contador de empresas */}
      <Paper elevation={3} sx={{ p: 2, mb: 3, textAlign: "center" }}>
        <Typography variant="h4">Empresas Registradas: {companies.length}</Typography>
      </Paper>

      {/* Tabla de empresas */}
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Nombre de la Empresa</TableCell>
              <TableCell>Email de Contacto</TableCell>
              <TableCell>Teléfono</TableCell>
              <TableCell>Industria</TableCell>
              <TableCell>Acciones</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {currentCompanies.map((company) => (
              <TableRow key={company.id}>
                <TableCell>{company.companyName || "Sin nombre"}</TableCell>
                <TableCell>{company.contactEmail || "No especificado"}</TableCell>
                <TableCell>{company.contactPhone || "No especificado"}</TableCell>
                <TableCell>{company.industry || "No especificada"}</TableCell>
                <TableCell>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => handleOpenModal(company)}
                    sx={{ mr: 1 }}
                  >
                    Ver
                  </Button>
                  <Button
                    variant="contained"
                    color="error"
                    onClick={() => handleDeleteCompany(company.id)}
                  >
                    Eliminar
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <TablePagination
          rowsPerPageOptions={[companiesPerPage]}
          component="div"
          count={companies.length}
          rowsPerPage={companiesPerPage}
          page={currentPage}
          onPageChange={handleChangePage}
        />
      </TableContainer>

      {/* Modal para ver detalles de la empresa */}
      <Modal open={isModalOpen} onClose={handleCloseModal}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 500,
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            p: 4,
          }}
        >
          <Typography variant="h6" component="h2" sx={{ mb: 2 }}>
            Detalles de la Empresa
          </Typography>
          {selectedCompany && (
            <>
              <Typography>
                <strong>ID:</strong> {selectedCompany.id}
              </Typography>
              <Typography>
                <strong>Nombre:</strong> {selectedCompany.companyName || "Sin nombre"}
              </Typography>
              <Typography>
                <strong>Email de Contacto:</strong> {selectedCompany.contactEmail || "No especificado"}
              </Typography>
              <Typography>
                <strong>Teléfono:</strong> {selectedCompany.contactPhone || "No especificado"}
              </Typography>
              <Typography>
                <strong>Dirección:</strong> {selectedCompany.address || "No especificada"}
              </Typography>
              <Typography>
                <strong>Ciudad:</strong> {selectedCompany.city || "No especificada"}
              </Typography>
              <Typography>
                <strong>Industria:</strong> {selectedCompany.industry || "No especificada"}
              </Typography>
              <Typography>
                <strong>Empleados:</strong> {selectedCompany.employees || "No especificado"}
              </Typography>
              <Typography>
                <strong>Logo:</strong>{" "}
                {selectedCompany.logo ? (
                  <img
                    src={selectedCompany.logo}
                    alt="Logo"
                    style={{ maxWidth: "100%", height: "auto" }}
                  />
                ) : (
                  "No disponible"
                )}
              </Typography>
              <Typography>
                <strong>Última Actualización:</strong>{" "}
                {selectedCompany.updatedAt ? new Date(selectedCompany.updatedAt.seconds * 1000).toLocaleString() : "No especificada"}
              </Typography>
            </>
          )}
          <Button
            variant="contained"
            color="primary"
            onClick={handleCloseModal}
            sx={{ mt: 2 }}
          >
            Cerrar
          </Button>
        </Box>
      </Modal>
    </Box>
  );
};

export default Companies;
